import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Spinner } from "reactstrap"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { map, range } from "lodash"

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from "react-bootstrap-table2-toolkit"

//actions
import { getProducts } from "store/actions"

import "../../assets/scss/datatables.scss"
import defualtProduct from "../../assets/images/product.jpeg"

import MyPagination from "components/Common/MyPagination"
import { post } from "helpers/api_methods"

const Products = () => {
  const dispatch = useDispatch()
  const [searchText, setSearchText] = useState("")

  const { products, loading } = useSelector(state => ({
    products: state.Products.products,
    loading: state.Products.loading,
  }))

  //pagination
  const [limit] = useState("10")
  const [page, setPage] = useState(1)
  const totalPages = Math.ceil(products?.count / limit)
  const pages = range(1, totalPages + 1)

  useEffect(() => {
    dispatch(getProducts(searchText, page))
  }, [dispatch, page, searchText])

  const handleDuplicateProduct = async (id) => {
    try {
      await post(`/store/product/${id}/duplicate/`)
      dispatch(getProducts(searchText, page))
    } catch (err) {
      console.error("Failed to duplicate product", err)
    }
  }

  const columns = [
    {
      dataField: "sl",
      text: "Sl",
    },
    {
      dataField: "product_code",
      text: "Product Code",
    },
    {
      dataField: "image",
      text: "Image",
    },
    {
      dataField: "name",
      text: "Product",
      sort: true,
    },
    {
      dataField: "cost",
      text: "Cost",
    },
    {
      dataField: "profit",
      text: "Profit",
    },
    {
      dataField: "action",
      text: "Action",
    },
  ]

  const newColumns = [
    {
      dataField: "product_code",
      text: "Product Code",
    },
    {
      dataField: "image",
      text: "Image",
    },
    {
      dataField: "name",
      text: "Product",
      sort: true,
    },
    {
      dataField: "mrp",
      text: "Price",
    },
    {
      dataField: "action",
      text: "Action",
    },
  ]

  const Role = sessionStorage.getItem("role")

  const handleProductCost = () => {
    if (Role === "admin" || Role === "generalmanager") {
      return true
    }
  }
  const productData = map(products?.results, (item, index) => ({
    ...item,
    key: index,
    sl: <span>{(page - 1) * 10 + (index + 1)}</span>,
    image: (
      <Link to={`products/${item?.id}`}>
        <img
          src={item.image ? item.image : defualtProduct}
          alt={item.name && item.name}
          className="avatar-md"
        />
      </Link>
    ),
    mrp: <p>{item?.mrp}</p>,
    name: (
      <div
        style={{
          whiteSpace: "pre-wrap",
          maxWidth: "150px",
        }}
      >
        <p>{item.name}</p>
      </div>
    ),
    action: (
      <div>
        <Link to={`products/${item?.id}`} className="btn btn-light btn-sm me-2">
          View Details
        </Link>
        <button
          type="button"
          className="btn btn-outline-primary btn-sm"
          onClick={() => handleDuplicateProduct(item.id)}
        >
          <i className="fas fa-copy me-1"></i>Duplicate
        </button>
      </div>
    ),
  }))

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  // Select All Button operation
  const selectRow = {
    mode: "checkbox",
  }

  const handleSearch = e => {
    setSearchText(e.target.value)
  }

  return (
    <React.Fragment>
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <ToolkitProvider
                keyField="id"
                columns={handleProductCost() ? columns : newColumns}
                data={productData}
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row className="mb-2">
                      <Col md="4">
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <div className="position-relative">
                            <form
                              className="app-search d-lg-block"
                              onChange={e => handleSearch(e)}
                            >
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search..."
                                  defaultValue={searchText}
                                />
                                <span className="bx bx-search-alt" />
                              </div>
                            </form>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    {loading ? (
                      <Spinner color="secondary" className="d-block m-auto" />
                    ) : (
                      <>
                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField={"id"}
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                selectRow={selectRow}
                                classes={"table align-middle table-nowrap"}
                                headerWrapperClasses={"thead-light"}
                                {...toolkitProps.baseProps}
                              />
                            </div>
                          </Col>
                        </Row>
                        <MyPagination
                          totalPages={pages}
                          page={page}
                          setPage={setPage}
                        />
                      </>
                    )}
                  </React.Fragment>
                )}
              </ToolkitProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default Products
